<template>
  <form>
  <slot></slot>
  </form>
</template>
  
<script>
import { useGlobalProperties } from '/@/hooks/core/useGlobal'

export default {
  props: {
    model: { type: Object },
    rules: { type: Object }
  },
  provide() {
    return {
      eForm: this, // provide this component's instance
    }
  },
  data() {
    return {
      fields: [],
    }
  },
  created() {
    // 解释一
    this.fields = [];
    const bus = useGlobalProperties().$bus
    const { ee } = bus
    // this.$on('addField', field => this.fields.push(field));
    ee.on(ee.Event.AddField, field => this.fields.push(field))
  },
  methods: {
    async validate(cb) { // 解释二
      // 解释三
      const eachfieldResultArray = this.fields.map(field => field.validate());

      // 解释四
      const results = await Promise.all(eachfieldResultArray);
      let ret = true;
      results.forEach(valid => {
        if (!valid) {
          ret = false;
        }
      });
      cb(ret);
    }
  },
}
</script>
  
<style lang="scss" scoped>
</style>